// v2.0 stub. OneDrive repo detection is retired — no filesystem in the
// browser, no `users.json` lookup, no `settings.json` on disk. Kept only
// for signature compatibility with `SettingsScreen` and `session.ts` until
// those callers are removed.

export async function isValidRepo(_path: string): Promise<boolean> {
  return true;
}

export async function detectRepoPath(): Promise<string | null> {
  return "cloud://lens";
}

export type PickResult =
  | { status: "picked"; path: string }
  | { status: "cancelled" }
  | { status: "invalid" };

export async function pickRepoFolder(): Promise<PickResult> {
  return { status: "picked", path: "cloud://lens" };
}
